const choicesSocialCriteria = {
    minoritiesAndDisabilities: 'Inclusivité des minorités et handicaps',
    absenceOfProcess: 'Absence de processus et de mécanismes de contrôle de la conformité aux principes et orientations susvisés.',
    compensationGap: ' Écart de rémunération non ajusté entre les sexes.',
    employeeTraining: ' Formation des collaborateurs',
    ExposureToControversialWeapons: 'Exposition à des armes controversées (mines antipersonnel, armes à sous-munitions, armes chimiques et armes biologiques)',
};

export default choicesSocialCriteria;
